
import { GET_BADGE_NOTIF } from '@/dataSource/api/Notif/apiNiotif'
import { defineStore } from 'pinia'

interface TypeBadge {
    dataBadge: any
    countUnread: Number
}

export const DataBadgeNotif = defineStore('DataBadgeNotif', {
    state: () => <TypeBadge>({
        dataBadge: [],
        countUnread: 0
    }),
    actions: {
        async GetDateBadge() {
            if (window.navigator.onLine) {
                this.dataBadge = await GET_BADGE_NOTIF()
                this.countUnread = this.dataBadge.data.unread
            }
        }
    }
})